import React from 'react';
import { string, shape, boolean, arrayOf } from 'prop-types';
import classNames from 'classnames';
import handleEscapedCharacters from '../../js/utils/handleEscapedCharacters';
import GoogleIcon from '../google-icon';

function CourseTileFlag({ flag }) {
    let colorClass = '';

    switch (flag) {
        case 'Closing Soon':
        case 'Full':
        case 'Almost Full':
        case 'Closed':
            colorClass = 'flag-danger';
            break;
        case 'Filling Fast':
        case 'Waitlist':
            colorClass = 'flag-warning';
            break;
        default: colorClass = '';
    }

    return (
        <div className={`tile-flag ${colorClass}`}>
            {flag}
        </div>
    );
}

export default function CourseTile({
    item: {
        url,
        target,
        flag,
        imgUrl,
        title,
        subtitle,
        tags,
        location,
        date,
        calendar,
        hoverContent,
        hoverColour,
        locationConjunction,
        cricos
    }
}) {
    const separator = handleEscapedCharacters(locationConjunction);
    return (
        <a href={url} target={target ? target : '_self'} className={classNames(`c-course-tile ${hoverColour ? hoverColour : ''}`)}>
            {imgUrl && (
                <div className="tile-image">
                    <img src={imgUrl} alt={title} />
                </div>
            )}
            {flag && <CourseTileFlag flag={flag} /> }
            <div className="tile-content-wrapper">
                <div className="tile-primary">
                    <h3 className="tile-heading">{title}</h3>
                    <p className="tile-subheading">{subtitle}</p>
                    <div className="tile-tags">
                        <div className="tile-tags-icon"><GoogleIcon icon="description" /></div>
                        <div className="tile-tags-items">{tags}</div>
                    </div>
                    {cricos && (
                        <div className="course-codes">
                            <div className="course-codes-icon">
                                <GoogleIcon icon="info" />
                            </div>
                            <div className="course-codes-items">
                                <span dangerouslySetInnerHTML={{ __html: cricos }} />
                            </div>
                        </div>
                    )}
                </div>

                <div className="tile-secondary">
                    {location && (
                        <div className="tile-tags">
                            <div className="tile-tags-icon"><GoogleIcon icon="location_on" /></div>
                            <div className="tile-tags-items">
                                {location.map((loc, index) => (
                                    <span>
                                        {loc}
                                        {index < location.length - 1 ? ` ${separator} ` : ''}
                                    </span>
                                ))}
                            </div>
                        </div>
                    )}
                    {date && (
                        <div className="tile-tags">
                            <div className="tile-tags-icon"><GoogleIcon icon="schedule" /></div>
                            <div className="tile-tags-items">{date}</div>
                        </div>
                    )}
                    {calendar && (
                        <div className="tile-tags">
                            <div className="tile-tags-icon"><GoogleIcon icon="calendar_today" /></div>
                            <div className="tile-tags-items">{calendar}</div>
                        </div>
                    )}
                </div>
            </div>

            <div className={classNames(`tile-hover ${hoverColour ? hoverColour : ''}`)}>
                <h3 className="tile-hover-heading">{title}</h3>
                <div className="tile-hover-content">
                    <p>{hoverContent}</p>
                </div>
                <div className="tile-hover-ctas">
                    <div className="btn-skin-1">Learn More</div>
                </div>
            </div>
        </a>
    );
}
CourseTileFlag.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    flag: string.isRequired
    /* eslint-enable react/no-typos */
};

CourseTile.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    item: shape({
        url: string.isRequired,
        target: string,
        isApplicationOpen: boolean,
        imgUrl: string.isRequired,
        title: string.isRequired,
        subtitle: string.isRequired,
        tags: string.isRequired,
        location: arrayOf(string).isRequired,
        date: string.isRequired,
        calendar: string.isRequired,
        hoverColour: string,
        cricos: string
    }).isRequired
    /* eslint-enable react/no-typos */
};
